/**
 * lh-approx-location.js
 *
 * Fills any hidden [data-lh-approx-location] field with a coarse, IP-derived
 * "City, Region, Country" estimate, so the Shopify contact-form email can be
 * routed to the nearest showroom.
 *
 * Loaded from theme.liquid ONLY when the "Appointment Requests → Add
 * approximate location" theme setting is on. Paired with
 * snippets/lh-approx-location-field.liquid, which renders the field itself.
 *
 * Design notes:
 *  - The lookup fires on first interaction with a form, not on page load, so
 *    the many visitors who never touch a form cost nothing.
 *  - The request is made at most once per page and shared by every form on it
 *    (the contact and bridal drawers both live in theme.liquid, so a product
 *    page carries two).
 *  - Every failure is silent. An empty field simply drops the line from the
 *    email — this must never block or delay a customer's submission.
 *  - The "estimated from IP" caveat is baked into the value rather than left
 *    to the field label, so it cannot get separated from the data on its way
 *    to whoever reads the email.
 */
(function () {
  'use strict';

  var CAVEAT = ' (estimated from IP — may be inaccurate)';
  var TIMEOUT_MS = 4000;

  var tag = document.querySelector('script[data-geo-api-base]');
  var apiBase = (tag && tag.getAttribute('data-geo-api-base')) || '';
  apiBase = apiBase.replace(/\/+$/, '');

  var pending = null; // memoized promise — one request per page load

  function lookup() {
    if (pending) return pending;

    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, TIMEOUT_MS);

    pending = fetch(apiBase + '/api/geo', {
      method: 'GET',
      mode: 'cors',
      cache: 'no-store',
      credentials: 'omit',
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        clearTimeout(timer);
        return data && data.ok && data.label ? data.label : null;
      })
      .catch(function () {
        clearTimeout(timer);
        return null;
      });

    return pending;
  }

  function fill(field) {
    lookup().then(function (label) {
      // Guard against a second wire-up overwriting a value already in place.
      if (label && !field.value) field.value = label + CAVEAT;
    });
  }

  function wire(field) {
    var form = field.form || field.closest('form');
    if (!form || form.hasAttribute('data-lh-approx-wired')) return;
    form.setAttribute('data-lh-approx-wired', '');

    var start = function () { fill(field); };
    form.addEventListener('focusin', start, { once: true });
    form.addEventListener('pointerdown', start, { once: true });
  }

  function init() {
    if (!window.fetch || !apiBase) return;
    var fields = document.querySelectorAll('[data-lh-approx-location]');
    for (var i = 0; i < fields.length; i++) wire(fields[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
